import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enLayout from './locales/en/layout.json'
import enServicePrices from './locales/en/service-prices.json'
import enMarkupRules from './locales/en/markup-rules.json'
import enProviders from './locales/en/providers.json'
import enAgents from './locales/en/agents.json'
import enProjects from './locales/en/projects.json'
import enKnowledgeBases from './locales/en/knowledge-bases.json'
import enTriggers from './locales/en/triggers.json'
import enCredentials from './locales/en/credentials.json'
import enSessions from './locales/en/sessions.json'
import enFeatureTemplates from './locales/en/feature-templates.json'
import enMissions from './locales/en/missions.json'
import enWorkflows from './locales/en/workflows.json'
import enUsers from './locales/en/users.json'
import enIamTenants from './locales/en/iam-tenants.json'
import enDashboard from './locales/en/dashboard.json'
import enUsages from './locales/en/usages.json'
import enRuns from './locales/en/runs.json'
import enInbox from './locales/en/inbox.json'
import itCommon from './locales/it/common.json'
import itAuth from './locales/it/auth.json'
import itLayout from './locales/it/layout.json'
import itServicePrices from './locales/it/service-prices.json'
import itMarkupRules from './locales/it/markup-rules.json'
import itProviders from './locales/it/providers.json'
import itAgents from './locales/it/agents.json'
import itProjects from './locales/it/projects.json'
import itKnowledgeBases from './locales/it/knowledge-bases.json'
import itTriggers from './locales/it/triggers.json'
import itCredentials from './locales/it/credentials.json'
import itSessions from './locales/it/sessions.json'
import itFeatureTemplates from './locales/it/feature-templates.json'
import itMissions from './locales/it/missions.json'
import itWorkflows from './locales/it/workflows.json'
import itUsers from './locales/it/users.json'
import itIamTenants from './locales/it/iam-tenants.json'
import itDashboard from './locales/it/dashboard.json'
import itUsages from './locales/it/usages.json'
import itRuns from './locales/it/runs.json'
import itInbox from './locales/it/inbox.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it',
    defaultNS: 'common',
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        layout: enLayout,
        'service-prices': enServicePrices,
        'markup-rules': enMarkupRules,
        providers: enProviders,
        agents: enAgents,
        projects: enProjects,
        'knowledge-bases': enKnowledgeBases,
        triggers: enTriggers,
        credentials: enCredentials,
        sessions: enSessions,
        'feature-templates': enFeatureTemplates,
        missions: enMissions,
        workflows: enWorkflows,
        users: enUsers,
        'iam-tenants': enIamTenants,
        dashboard: enDashboard,
        usages: enUsages,
        runs: enRuns,
        inbox: enInbox,
      },
      it: {
        common: itCommon,
        auth: itAuth,
        layout: itLayout,
        'service-prices': itServicePrices,
        'markup-rules': itMarkupRules,
        providers: itProviders,
        agents: itAgents,
        projects: itProjects,
        'knowledge-bases': itKnowledgeBases,
        triggers: itTriggers,
        credentials: itCredentials,
        sessions: itSessions,
        'feature-templates': itFeatureTemplates,
        missions: itMissions,
        workflows: itWorkflows,
        users: itUsers,
        'iam-tenants': itIamTenants,
        dashboard: itDashboard,
        usages: itUsages,
        runs: itRuns,
        inbox: itInbox,
      },
    },
  })

export default i18n
